import createLead from "components/clientSideUtils/createLead";
import { useClientSideInfo } from "../useClientSideInfo";
import { trackEvent } from "../trackEvent";

export const createPurchaseIntentLead = async (
  {
    name,
    email,
    currentStep,
  }: {
    name: string;
    email: string;
    currentStep: string;
  },
  opts: ReturnType<typeof useClientSideInfo>
) => {
  const metadata = {
    offerIds: opts.offers.map((offer) => offer.id),
    name,
  };

  const resp = await createLead({
    ...opts,
    email,
    type: "purchase_intent",
    metadata,
  });

  if (resp.ok) {
    const createdLead = await resp.json();
    trackEvent("checkout-lead-created", {
      type: "checkout-lead-created",
      payload: {
        createdLead,
        currentStep,
        selectedOffers: opts.offers.map((offer) => {
          return {
            id: offer.id,
            name: offer.name,
            installments: offer.numberOfInstallmentsAllowed,
            bookedRevenue: offer.priceInCents,
          };
        }),
        ...opts,
      },
    });

    return createdLead;
  }
};
